import { useState } from 'react';

import { Overlay } from '@american-autonomy/ag-ui';

import FloatingResourceAddMenu from 'components/FloatingResourceAddMenu';
import AddButton from 'components/buttons/AddButton';

import { useFloatingResourceAddContext } from 'hooks/useFloatingResourceAddContext';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FloatingResourceAddButton: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { visible } = useFloatingResourceAddContext();
    const [isFloatingResourceMenuOpen, setIsFloatingResourceMenuOpen] = useState(false);

    const handleClick = () => setIsFloatingResourceMenuOpen(true);

    const handleClose = () => {
        setIsFloatingResourceMenuOpen(false);
    };

    const openClass = isFloatingResourceMenuOpen ? styles.open : '';

    if (!visible) {
        return null;
    }

    return (
        <Overlay className={`${openClass} ${styles.floatingResourceAddButton}`} testId={testId}>
            {isFloatingResourceMenuOpen ? (
                <FloatingResourceAddMenu onClose={handleClose} />
            ) : (
                <AddButton onClick={handleClick} />
            )}
        </Overlay>
    );
};

export default FloatingResourceAddButton;
